/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id   : 'Home',
        title: 'Home',
        type : 'basic',
        icon : 'heroicons_outline:home',
        link : '/home'
    },
    {
        id   : 'Calendar',
        title: 'Calendar',
        type : 'basic',
        icon : 'heroicons_outline:calendar',
        link : '/2'
    },
    {
        id   : 'Mesaje',
        title: 'Mesaje',
        type : 'basic',
        icon : 'heroicons_outline:envelope',
        link : '/3'
    },
    {
        id   : 'Tratamente',
        title: 'Tratamente',
        type : 'basic',
        icon : 'heroicons_outline:beaker',
        link : '/4'
    },
    {
        id   : 'Rapoarte',
        title: 'Rapoarte',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/5'
    },
    {
        id   : 'Setari',
        title: 'Setari',
        subtitle: 'aaaaaa',
        tooltip: 'Ceva explicatii',
        type : 'collapsable',
        icon : 'heroicons_outline:adjustments-horizontal',
        link : '/7',
        children:[
            {
                id   : 'Rapoarte',
                title: 'Rapoarte',
                type : 'basic',
                icon : 'heroicons_outline:chart-pie',
                link : 'https://www.smilesmanager.ro',
                externalLink: true,
            } ,
            {
                id   : 'Rapoarte',
                title: 'Rapoarte',
                type : 'basic',
                icon : 'heroicons_outline:chart-pie',
                link : '/5'
            }
        ]
    },
    {
        id   : 'Tutoriale',
        title: 'Tutoriale',
        type : 'basic',
        icon : 'heroicons_outline:film',
        link : '/6'
    }
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    },
    {
        id   : 'example',
        title: 'Pacienti',
        type : 'basic',
        icon : 'heroicons_outline:user',
        link : '/1'
    },
    {
        id   : 'example',
        title: 'Calendar',
        type : 'basic',
        icon : 'heroicons_outline:calendar',
        link : '/2'
    },
    {
        id   : 'example',
        title: 'Mesaje',
        type : 'basic',
        icon : 'heroicons_outline:envelope',
        link : '/3'
    },
    {
        id   : 'example',
        title: 'Tratamente',
        type : 'basic',
        icon : 'heroicons_outline:beaker',
        link : '/4'
    },
    {
        id   : 'example',
        title: 'Rapoarte',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/5'
    },
    {
        id   : 'example',
        title: 'Setari',
        type : 'basic',
        icon : 'heroicons_outline:adjustments-horizontal',
        link : '/7'
    },
    {
        id   : 'example',
        title: 'Tutoriale',
        type : 'basic',
        icon : 'heroicons_outline:film',
        link : '/6'
    }

];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    },
    {
        id   : 'Pacienti',
        title: 'Pacienti',
        type : 'basic',
        icon : 'heroicons_outline:user',
        link : '/1'
    },
    {
        id   : 'Calendar',
        title: 'Calendar',
        type : 'basic',
        icon : 'heroicons_outline:calendar',
        link : '/2'
    },
    {
        id   : 'Mesaje',
        title: 'Mesaje',
        type : 'basic',
        icon : 'heroicons_outline:envelope',
        link : '/3'
    },
    {
        id   : 'Tratamente',
        title: 'Tratamente',
        type : 'basic',
        icon : 'heroicons_outline:beaker',
        link : '/4'
    },
    {
        id   : 'Rapoarte',
        title: 'Rapoarte',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/5'
    },
    {
        id   : 'Setari',
        title: 'Setari',
        subtitle: 'aaaaaa',
        tooltip: 'Ceva explicatii',
        type : 'collapsable',
        icon : 'heroicons_outline:adjustments-horizontal',
        link : '/7',
        children:[
            {
                id   : 'Rapoarte',
                title: 'Rapoarte',
                type : 'basic',
                icon : 'heroicons_outline:chart-pie',
                link : 'https://www.smilesmanager.ro',
                externalLink: true,
            } ,
            {
                id   : 'Rapoarte',
                title: 'Rapoarte',
                type : 'basic',
                icon : 'heroicons_outline:chart-pie',
                link : '/5'
            }
        ]
    },
    {
        id   : 'Tutoriale',
        title: 'Tutoriale',
        type : 'basic',
        icon : 'heroicons_outline:film',
        link : '/6'
    }
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    },
    {
        id   : 'Pacienti',
        title: 'Pacienti',
        type : 'basic',
        icon : 'heroicons_outline:user',
        link : '/1'
    },
    {
        id   : 'Calendar',
        title: 'Calendar',
        type : 'basic',
        icon : 'heroicons_outline:calendar',
        link : '/2'
    },
    {
        id   : 'Mesaje',
        title: 'Mesaje',
        type : 'basic',
        icon : 'heroicons_outline:envelope',
        link : '/3'
    },
    {
        id   : 'Tratamente',
        title: 'Tratamente',
        type : 'basic',
        icon : 'heroicons_outline:beaker',
        link : '/4'
    },
    {
        id   : 'Rapoarte',
        title: 'Rapoarte',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/5'
    },
    {
        id   : 'Setari',
        title: 'Setari',
        subtitle: 'aaaaaa',
        tooltip: 'Ceva explicatii',
        type : 'collapsable',
        icon : 'heroicons_outline:adjustments-horizontal',
        link : '/7',
        children:[
            {
                id   : 'Rapoarte',
                title: 'Rapoarte',
                type : 'basic',
                icon : 'heroicons_outline:chart-pie',
                link : 'https://www.smilesmanager.ro',
                externalLink: true,
            } ,
            {
                id   : 'Rapoarte',
                title: 'Rapoarte',
                type : 'basic',
                icon : 'heroicons_outline:chart-pie',
                link : '/5'
            }
        ]
    },
    {
        id   : 'Tutoriale',
        title: 'Tutoriale',
        type : 'basic',
        icon : 'heroicons_outline:film',
        link : '/6'
    }
];
